import React from 'react';
import { Provider } from 'react-redux';
import GlobalStyles from '@iso/assets/styles/globalStyle';
import { store } from './redux/store';
import Boot from './redux/boot';
import AppRoute from './router';
import AppProvider from './AppProvider';
import { ToastProvider } from '@shared/toast';
import '@iso/assets/styles/tailwind.css';
import '@iso/assets/styles/global.css';
import '@iso/assets/styles/style.css';
// Import all playfair-display
import '@fontsource/playfair-display';
import { QueryClient, QueryClientProvider } from 'react-query';
const queryClient = new QueryClient()

const App = () => (
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <AppProvider>
        <ToastProvider>
          <>
            <GlobalStyles />
            <AppRoute />
          </>
        </ToastProvider>
      </AppProvider>
    </Provider>
  </QueryClientProvider>
);
Boot()
  .then(() => App())
  .catch((error) => console.error(error));

export default App;
